import { z } from 'zod'

export const loginSchema = z.object({
  email: z.email({ error: 'Enter a valid email address' }),
  password: z.string().min(1, { error: 'Enter your password' }),
  remember: z.boolean(),
})

export type LoginValues = z.infer<typeof loginSchema>

export const recoverySchema = z.object({
  email: z.email({ error: 'Enter a valid email address' }),
  code: z.string().trim().min(1, { error: 'Enter one of your recovery codes' }),
  remember: z.boolean(),
})

export type RecoveryValues = z.infer<typeof recoverySchema>
